import React from 'react';
import { AlertTriangle, Shield, FileText } from 'lucide-react';

const AMFICompliance = () => {
  return (
    <div className="bg-slate-50 border-2 border-slate-300 rounded-lg p-6 my-8">
      <div className="flex items-start gap-4 mb-4">
        <Shield className="text-blue-600 flex-shrink-0" size={32} />
        <div>
          <h3 className="text-xl font-bold text-slate-900 mb-2">AMFI Registration & Compliance</h3>
          <div className="text-sm text-slate-700 space-y-1">
            <p><strong>ARN:</strong> 102867 | <strong>Initial Registration:</strong> 09-June-2015 | <strong>Valid till:</strong> 01-07-2027</p>
            <p><strong>SIF:</strong> Valid till 15-03-2029</p>
            <p><strong>APRN:</strong> Valid till 17-10-2027</p>
          </div>
        </div>
      </div>

      <div className="space-y-4 text-sm text-slate-800">
        {/* Commission Disclosure */}
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
          <p className="font-semibold text-blue-900 mb-2 flex items-center gap-2">
            <FileText size={18} />
            Commission Disclosure
          </p>
          <p className="text-blue-800">
            As an AMFI registered Mutual Fund Distributor (MFD), we earn commission from Asset Management Companies (AMCs) 
            in the form of <strong>Trail Commission only</strong>. We do not charge any fees directly from investors. 
            The commission structure does not affect the NAV of the schemes.
          </p>
        </div>

        {/* Regulatory Disclaimers */}
        <div className="bg-red-50 border-l-4 border-red-500 p-4">
          <p className="font-semibold text-red-900 mb-2 flex items-center gap-2">
            <AlertTriangle size={18} />
            Statutory Disclaimer
          </p>
          <ul className="space-y-2 text-red-800">
            <li className="flex items-start gap-2">
              <span className="font-bold">•</span>
              <span>
                <strong>Mutual fund investments are subject to market risks, read all scheme related documents carefully.</strong>
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold">•</span>
              <span>
                Past performance is not indicative of future returns. The NAV of the scheme(s) may go up or down depending upon 
                the factors and forces affecting the securities market including the fluctuations in the interest rates.
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold">•</span>
              <span>
                The sponsor/AMC is not responsible or liable for any loss or shortfall resulting from the operation of the scheme(s).
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold">•</span>
              <span>
                Investors should deal only with registered Mutual Funds, details of which can be verified on the SEBI/AMFI website.
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold">•</span>
              <span>
                <strong>Grievance Officer:</strong> Prem Prakash Bhansali<br/>
                For investor complaints/grievances, please contact: <strong>complaints@rubiconfinservices.com</strong> or 
                file complaint on <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">scores.sebi.gov.in</a>
              </span>
            </li>
          </ul>
        </div>

        {/* Investment Advisory */}
        <div className="bg-amber-50 border-l-4 border-amber-500 p-4">
          <p className="font-semibold text-amber-900 mb-2">Investment Advisory</p>
          <ul className="space-y-2 text-amber-800 text-xs">
            <li>• This website is for information purposes only and should not be construed as an offer to sell or solicitation to buy any securities.</li>
            <li>• Investors should make their own investigations and evaluations of the schemes before investing.</li>
            <li>• The information provided does not have regard to specific investment objectives, financial situation, and particular needs of any specific person.</li>
            <li>• Investors are advised to consult their own tax consultant, legal and financial advisors before making any investment decision.</li>
            <li>• All investments in mutual funds are subject to market risks and there is no assurance or guarantee that the objectives will be achieved.</li>
            <li>• Neither Rubicon Finservices nor any of its affiliates, group companies, directors or employees shall be liable for any loss, damage of any nature arising out of use of information provided.</li>
          </ul>
        </div>

        {/* MSME Registration */}
        <div className="bg-green-50 border-l-4 border-green-500 p-4">
          <p className="font-semibold text-green-900 mb-1">MSME Registration</p>
          <p className="text-green-800 text-xs">
            UDYAM Registration Number: <strong>UDYAM-WB-14-0192124</strong>
          </p>
        </div>

        {/* Registered Office */}
        <div className="border-t pt-4 mt-4">
          <p className="text-xs text-slate-600">
            <strong>Registered Office:</strong> 6A Dr.Rajendra Prasad Sarani, 4th Floor, R.No-20, Kolkata-700001 | 
            <strong> Email:</strong> communications@rubiconfinservices.com | 
            <strong> Phone:</strong> +91-33-40442577
          </p>
        </div>
      </div>
    </div>
  );
};

export default AMFICompliance;
